import { useMediaQuery, useTheme } from '@mui/material';

/**
 * Mobile-detection hook for the responsive/PWA effort.
 *
 * Returns true when the viewport is below the `md` breakpoint (960px), i.e.
 * phones and small tablets. Desktop (>= md) is unaffected — callers must keep
 * every mobile branch a no-op on desktop (see plan gate 1.7).
 *
 * Usage:
 *   const isMobile = useIsMobile();
 *   <Box sx={{ p: isMobile ? 1 : 3 }} />
 *
 * Prefer inline `sx={{ prop: { xs, md } }}` for pure style props; reach for this
 * hook when a value drives logic/JSX branching (chart height, hiding animations).
 */
export function useIsMobile(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('md'));
}

export default useIsMobile;
